<template>
	<div>
		<base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-pink">
			<!-- Card stats -->
			<b-row>
				<b-col
					xl="3"
					md="6"
				>
					<stats-card
						title="Avaluos Asignados"
						type="gradient-red"
						sub-title="350,897"
						icon="ni ni-active-40"
						class="mb-4"
					>
						<template slot="footer">
							<span class="text-success mr-2">3.48%</span>
							<span class="text-nowrap">Desde el ultimo mes</span>
						</template>
					</stats-card>
				</b-col>
				<b-col
					xl="3"
					md="6"
				>
					<stats-card
						title="Avaúlos en Proceso"
						type="gradient-orange"
						sub-title="2,356"
						icon="ni ni-chart-pie-35"
						class="mb-4"
					>
						<template slot="footer">
							<span class="text-success mr-2">12.18%</span>
							<span class="text-nowrap">Desde el ultimo mes</span>
						</template>
					</stats-card>
				</b-col>
				<b-col
					xl="3"
					md="6"
				>
					<stats-card
						title="Avalúos Finalizado"
						type="gradient-green"
						sub-title="924"
						icon="ni ni-money-coins"
						class="mb-4"
					>
						<template slot="footer">
							<span class="text-danger mr-2">5.72%</span>
							<span class="text-nowrap">Desde el ultimo mes</span>
						</template>
					</stats-card>
				</b-col>
				<b-col
					xl="3"
					md="6"
				>
					<stats-card
						title="Avalúos en Revisión"
						type="gradient-info"
						sub-title="49,65%"
						icon="ni ni-chart-bar-32"
						class="mb-4"
					>
						<template slot="footer">
							<span class="text-success mr-2">54.8%</span>
							<span class="text-nowrap">Desde el ultimo mes</span>
						</template>
					</stats-card>
				</b-col>
			</b-row>
		</base-header>

		<!-- v-on:row-click="onShowInfo" -->

		<b-container
			fluid
			class="mt--7"
		>
			<b-row>
				<b-col>
					<data-table
						title=""
						:printable="false"
						:columns="headers"
						:rows="$assignments"
						class="m-data-table tw-mt-7 tw-w-full tw-overflow-auto scrollbar-x tw-rounded"
					>
						<template #[`item.actions`]="{ item }">
							<td>
								<b-button-group
									size="sm"
									class="tw-shadow-none"
								>
									<!-- <b-button variant="success">Update</b-button> -->
									<!-- @click="onInitUpdateItem(item)" -->
									<b-button variant="danger">Delete</b-button>
									<!-- @click="onDeleteItem(item)" -->

								</b-button-group>
							</td>
						</template>
					</data-table>
					<!-- <light-table /> -->
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import {
	Dropdown,
	DropdownItem,
	DropdownMenu,
	Table,
	TableColumn
} from "element-ui";
import projects from "./Tables/projects";
import users from "./Tables/users";
import LightTable from "./Tables/RegularTables/LightTable";
import DarkTable from "./Tables/RegularTables/DarkTable";
import { mapActions, mapGetters } from 'vuex';


import DataTable from "vue2-matable"

export default {
	name: "Appraisals",
	components: {
		LightTable,
		DarkTable,
		DataTable,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn
	},
	data() {
		return {
			projects,
			users,
			headers: [
				{ field: 'expert.name', label: 'Perito' },
				{ field: 'client', label: 'Cliente' },
				{ field: 'phone', label: 'Telefono' },
				{ field: 'town', label: 'Ciudad' },
				{ field: 'appraisalType', label: 'Tipo de Avaluo' },
				{ field: 'observation', label: 'Observacion' },
				{ field: 'marketValue', label: 'Valor de Mercado' },
				{ field: 'realizationValue', label: 'Valor Realización' },
				{ field: 'accountOfficer', label: 'Oficial de Cuenta' },
				{ field: 'location.name', label: 'Ubicacion' },
				{ field: 'actions', label: 'Actions' },
			],
		};
	},
	created() {
		this.subscribeAssignments()
	},
	computed: {
		...mapGetters('assignments', ['$assignments'])
	},
	methods: {
		...mapActions('assignments', ['subscribeAssignments'])
	}
};
</script>
<style>
	.el-table.table-dark {
		background-color: #172b4d;
		color: #f8f9fe;
	}

	.el-table.table-dark th,
	.el-table.table-dark tr {
		background-color: #172b4d;
	}

	.el-table.table-dark td,
	.el-table.table-dark th.is-leaf {
		border-bottom: none;
	}
</style>
